import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const HandheldMonitoringRBAC = {
  pageID: '58b0f28eac39c5de5bfcac606923c7cd',
  elementID: {
    BtnUnregisterItem: '29a6bcaae1b2b36f0e4154b590e974bc',
    BulkUnregister: '7be0833f98695a108f0a0d17ee11fdcb',
  },
} as const

export const useRBACHandheldMonitoringPage = createUseRBAC(HandheldMonitoringRBAC.elementID)
export type UseRBACHandheldMonitoringPageType = ReturnType<typeof useRBACHandheldMonitoringPage>
